import React, { useState } from "react";
import { banState, updateBanStatus } from "service/exam";
import { Button, Checkbox } from "antd";
import PopConfirm from "../../../components/PopConfirm";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import styles from "./index.module.scss";
import { CheckboxValueType } from "antd/es/checkbox/Group";

interface ButtonBanProps {
    examId: string;
    stuNo: string;
    onOk(): void;
}

export function ButtonBan({ examId, stuNo, onOk }: ButtonBanProps) {
    const [banInfo, setBaninfo] = useState<CheckboxValueType[]>([]);

    const [handleBan] = useRequestFn(async () => {
        try {
            await updateBanStatus(
                examId,
                banState.confirm,
                stuNo,
                banInfo.join(",")
            );
            onOk();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    });

    const options = [
        { label: "未参考", value: "未参考" },
        { label: "切屏3次", value: "切屏3次" },
        { label: "开启双屏", value: "开启双屏" },
        { label: "有作弊行为", value: "有作弊行为" },
        { label: "下载试卷", value: "下载试卷" }
    ];

    return (
        <PopConfirm
            title={
                <div style={{ width: 250 }}>
                    <p>禁考成功后，该考生不能再打开试卷或提交试卷，确认禁考?</p>
                    <p className={styles.info}>
                        提示：您可以通过选中标签的方式告知考生被禁考的原因
                    </p>
                    <Checkbox.Group
                        options={options}
                        value={banInfo}
                        onChange={setBaninfo}
                    />
                </div>
            }
            onConfirm={handleBan}>
            <Button className={styles.button} type="link">
                禁考
            </Button>
        </PopConfirm>
    );
}
